import { ReactNode } from 'react'

import {
    Divider,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react'
import clsx from 'clsx'

interface Props {
    title?: string
    body: ReactNode | string
    footer?: ReactNode | string
    isOpen: boolean
    onClose: () => void
    size?: string
    isHeaderVisible?: boolean | undefined
    isFooterVisible?: boolean | undefined
    toBottom?: boolean
    showOverlay?: boolean
    showFrom?: 'scale' | 'none' | 'slideInBottom' | 'slideInTop'
    isCentered?: boolean
    classNameBody?: string
    scrollBehavior?: 'inside' | 'outside'
    removeBorders?: boolean
    isV2Modal?: boolean
}

const baseClass = 'CustomModal'

export const CustomModal = ({
    title,
    body,
    footer,
    isOpen,
    onClose,
    size,
    isHeaderVisible = true,
    isFooterVisible = true,
    toBottom = false,
    showOverlay = true,
    showFrom = 'scale',
    classNameBody = '',
    scrollBehavior = 'inside',
    removeBorders = false,
    isV2Modal = false,
}: Props): JSX.Element => {
    return (
        <Modal
            className={baseClass}
            isOpen={isOpen}
            // scrollBehavior={isDesktop ? 'outside' : 'inside'}
            scrollBehavior={scrollBehavior}
            onClose={onClose}
            size={size}
            // @ts-ignore
            motionPreset={showFrom}
            isCentered={true}
            autoFocus={false}
            isLazy
            // blockScrollOnMount={false}
        >
            <ModalOverlay hidden={!showOverlay} className={`${baseClass}__overlay`} />
            <ModalContent
                className={`${baseClass}__content`}
                alignSelf={toBottom ? 'flex-end' : 'center'}
                marginBottom={toBottom ? 0 : 'auto'}
                position={'relative'}
                maxH="96vh"
                display="flex"
                flexDirection="column"
                borderRadius={isV2Modal ? '16px' : '8px'}
            >
                {isHeaderVisible && (
                    <>
                        <ModalHeader
                            position="sticky"
                            top={0}
                            zIndex={1}
                            bg="white"
                            borderTopLeftRadius={isV2Modal ? '16px' : '8px'}
                            borderTopRightRadius={isV2Modal ? '16px' : '8px'}
                            className={`${baseClass}__header`}
                            px={{ base: '16px', md: '24px' }}
                            py={{ base: '12px', md: '16px' }}
                        >
                            <HStack gap={'12px'}>
                                <Text flex={1} maxW={'90%'}>
                                    {title}
                                </Text>
                                <ModalCloseButton top={{ base: 3, md: 4 }} />
                            </HStack>
                        </ModalHeader>

                        {!removeBorders && <Divider />}
                    </>
                )}

                <ModalBody
                    className={clsx(`${baseClass}__body`, classNameBody)}
                    p={0}
                    border={toBottom && !removeBorders ? '1px solid #e0e0e0' : 'none'}
                    boxShadow={toBottom ? '0px -8px 40px 0px rgba(0, 0, 0, 0.08)' : 'none'}
                    flex="1"
                    overflowY="auto"
                    overscrollBehavior={'contain'}
                >
                    {body}
                </ModalBody>

                {isFooterVisible && footer && (
                    <>
                        {!removeBorders && <Divider />}
                        <ModalFooter
                            className={`${baseClass}__footer`}
                            p={4}
                            display="flex"
                            justifyContent="flex-end"
                            position="sticky"
                            bottom={0}
                            zIndex={1}
                            bg="white"
                            borderBottomLeftRadius={isV2Modal ? '16px' : '8px'}
                            borderBottomRightRadius={isV2Modal ? '16px' : '8px'}
                        >
                            {footer}
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    )
}
